module.exports = __webpack_public_path__ + "static/img/tea_fondo.8fac35d.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img/tea_fondo.png
// module id = FKR1
// module chunks = 0